// Mock data for Maison Gourmandise - artisan pastry showcase site
// NOTE: All data here is MOCKED for the frontend-only teaser.

export const brand = {
  name: "Rim Patisse",
  tagline: "Pâtisserie artisanale",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/3v47fawl_EB68074F-75D8-4CBF-BF34-21D942A41F55.webp",
  marquee: "L'ART DE LA GOURMANDISE",
  phone: "06 28 25 61 54",
  email: "ri_dak@yahoo.fr",
  address: "Pantin, Île-de-France",
  hours: "Mardi au Samedi · 9h – 19h",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    pinterest: "https://pinterest.com",
  },
};

export const navItems = [
  { label: "Accueil", path: "/" },
  { label: "À propos de moi", path: "/a-propos" },
  { label: "Nos gâteaux", path: "/gateaux" },
  { label: "Nos cupcakes et desserts", path: "/cupcakes-desserts" },
  { label: "Nos cookies", path: "/cookies" },
  { label: "Nos trompe-l'œil", path: "/trompe-loeil" },
  { label: "Mes réalisations", path: "/mes-realisations" },
  { label: "Devis sur mesure", path: "/devis" },
  { label: "Contact", path: "/contact" },
];

export const realisations = [
  { id: "r1", title: "Cœur rouge & or", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/mpcvinkm_ea2f11d1-df64-4eeb-96b6-e34fdf28ad28.JPG" },
  { id: "r2", title: "Anniversaire plage", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/sw9d2yr4_d7f1dc74-dbe5-4f30-b312-7ec6d1d214e3.JPG" },
  { id: "r3", title: "Pizzacookie fruits & noix", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/5ngclasu_07957631-5bc2-4efe-bc7f-435ad6121663.JPG" },
  { id: "r4", title: "Gâteau logo entreprise", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/qimifoit_212325e1-31df-4146-9bd7-63950f5d5802.webp" },
  { id: "r5", title: "Trompe-l'œil framboise", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/g1dkhn27_12e09fc0-89ed-49c1-9683-dd3556789232.JPG" },
];

export const announcements = [
  "BIENVENUE DANS L'UNIVERS DE RIM",
  "COMMANDES SUR MESURE POUR TOUS VOS ÉVÉNEMENTS",
  "L'ART DE LA GOURMANDISE, FAIT MAISON AVEC PASSION",
];

export const heroSlides = [
  {
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/jzwbfcpo_IMG_3932.jpeg",
    kicker: "Créations sur mesure",
    line1: "La gourmandise n'est pas un défaut",
    line2: "c'est une passion !",
    cta: "Voir mes réalisations",
  },
  {
    image:
      "https://images.unsplash.com/photo-1521310137449-68ce7d967620?w=1600&q=80&auto=format&fit=crop",
    kicker: "Mariages & célébrations",
    line1: "Des gâteaux qui racontent une histoire",
    line2: "un souvenir inoubliable",
    cta: "Découvrir",
  },
];

export const categories = {
  gateaux: {
    key: "gateaux",
    title: "Nos gâteaux",
    subtitle: "Layer cakes & bento cakes",
    intro:
      "Des gâteaux généreux et raffinés, moelleux à cœur, décorés à la main selon vos envies. Layer cakes et bento cakes individuels, sur mesure pour toutes vos occasions.",
    hero:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/fqi1pcrr_47623819-fa45-4944-b43a-d0106427493f.webp",
    products: [
      { id: "g1", name: "Layer Cake", price: "", desc: "Gâteau à étages élégant, décoré à la main de fleurs, perles et feuilles d'or.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/276c5yw9_655201057_17938617516190524_1902844288326430343_n.jpg" },
    ],
  },
  "cupcakes-desserts": {
    key: "cupcakes-desserts",
    title: "Nos cupcakes et desserts",
    subtitle: "Cupcakes moelleux et gourmands",
    intro:
      "De délicates petites gourmandises : des cupcakes moelleux surmontés d'une crème onctueuse, à personnaliser selon vos envies.",
    hero:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/vob7ya28_IMG_3965.jpeg",
    products: [
      { id: "c1", name: "Cupcakes", price: "", desc: "Cupcakes moelleux, crème au beurre meringuée.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/7zizcj79_6be6bce2-cea9-4b69-97b1-985d5068ae0d.JPG" },
    ],
  },
  cookies: {
    key: "cookies",
    title: "Nos cookies",
    subtitle: "Cookies & pizzacookies",
    intro:
      "Des cookies généreux préparés maison, avec du bon chocolat et des ingrédients sélectionnés. À déguster, à offrir ou à partager avec notre pizzacookie.",
    hero:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/pfpbz315_ff883c58-1df3-4b60-89d1-07ddf5113b10.webp",
    products: [
      { id: "k1", name: "Cookies", price: "", desc: "Cookies pépites de chocolat, croquants dehors, moelleux dedans.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/42kfuhxv_aa3e4be5-afe0-45df-b77c-c0fe84cc96b5.webp" },
      { id: "k2", name: "Cookies Trois Chocolats", price: "", desc: "Cookies aux trois chocolats, ultra gourmands.", image: "https://images.unsplash.com/photo-1598839950984-034f6dc7b495?w=800&q=80&auto=format&fit=crop" },
      { id: "k3", name: "Pizzacookie à Partager", price: "", desc: "Un immense cookie moelleux à partager.", image: "https://images.unsplash.com/photo-1634188023615-7e08901193b6?w=800&q=80&auto=format&fit=crop" },
      { id: "k4", name: "Cookies Noix de Pécan", price: "", desc: "Caramel & noix de pécan torréfiées.", image: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=800&q=80&auto=format&fit=crop" },
      { id: "k5", name: "Cookie Spéculoos Crunchy", price: "", desc: "Cœur fondant, pépites de chocolat et éclats de spéculoos croustillants.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/tj2hkqhj_IMG_3984.webp" },
      { id: "k6", name: "Cookie Matcha Framboise", price: "", desc: "Un cookie au matcha délicat, contrasté par des morceaux de framboises acidulées.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/n6ggjcvz_IMG_3976.webp" },
    ],
  },
  "trompe-loeil": {
    key: "trompe-loeil",
    title: "Nos trompe-l'œil",
    subtitle: "Des gâteaux hyper réalistes qui bluffent vos invités",
    intro:
      "L'illusion parfaite : des gâteaux sculptés à la main qui imitent à s'y méprendre les objets du quotidien. Un effet waouh garanti, 100% pâtisserie, à partir de 5 €.",
    hero:
      "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/lz2r7g5i_9957b355-b775-4dc6-a82b-ccb044ff95d2.webp",
    products: [
      { id: "t1", name: "Gâteaux personnalisés", price: "", desc: "Des créations uniques imaginées selon vos envies, votre thème et l'occasion à célébrer.", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/ipuw1hjb_655201057_17938617516190524_1902844288326430343_n.jpg" },
      { id: "t2", name: "Combi Vintage en Gâteau", price: "À partir de 5 €", desc: "Réplique d'un van rétro, effet bluffant.", image: "https://images.unsplash.com/photo-1768492489440-d7b89e7ae679?w=800&q=80&auto=format&fit=crop" },
      { id: "t3", name: "Petite Maison Gourmande", price: "À partir de 5 €", desc: "Maison miniature réaliste, décor minutieux.", image: "https://images.unsplash.com/photo-1583041270514-f2daa9ffc6d7?w=800&q=80&auto=format&fit=crop" },
      { id: "t4", name: "Création Personnalisée", price: "À partir de 5 €", desc: "Imaginez l'objet, je le transforme en gâteau.", image: "https://images.unsplash.com/photo-1649773289945-93a96051fd18?w=800&q=80&auto=format&fit=crop" },
    ],
  },
};

export const featured = [
  {
    id: "f-trompe",
    name: "Trompe l'œil",
    price: "",
    desc: "Des gâteaux hyper réalistes qui bluffent tous vos invités.",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/lz2r7g5i_9957b355-b775-4dc6-a82b-ccb044ff95d2.webp",
  },
  categories["cupcakes-desserts"].products[0],
  categories.cookies.products[0],
  categories["trompe-loeil"].products[0],
];

export const homeCategoryCards = [
  { title: "Nos gâteaux", path: "/gateaux", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/fqi1pcrr_47623819-fa45-4944-b43a-d0106427493f.webp" },
  { title: "Nos cupcakes et desserts", path: "/cupcakes-desserts", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/vob7ya28_IMG_3965.jpeg" },
  { title: "Nos cookies", path: "/cookies", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/pfpbz315_ff883c58-1df3-4b60-89d1-07ddf5113b10.webp" },
  { title: "Nos trompe-l'œil", path: "/trompe-loeil", image: "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/lz2r7g5i_9957b355-b775-4dc6-a82b-ccb044ff95d2.webp" },
];

export const homeIntroImage =
  "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/de8buxw2_IMG_3938.JPG";

export const about = {
  image:
    "https://images.unsplash.com/photo-1519733870-f96bef9bc85f?w=1000&q=80&auto=format&fit=crop",
  image2:
    "https://images.unsplash.com/photo-1649773289945-93a96051fd18?w=1000&q=80&auto=format&fit=crop",
  name: "Rim",
  title: "Bienvenue chez Rim'pâtisse 🤍",
  paragraphs: [
    "Derrière Rim'pâtisse, il y a tout simplement moi, Rim, une passionnée de pâtisserie qui aime transformer de bonnes idées en créations gourmandes.",
    "J'ai toujours aimé pâtisser, créer, tester de nouvelles choses et surtout faire plaisir à travers mes desserts. Aujourd'hui, j'ai la chance de pouvoir partager cette passion avec vous et de donner vie à vos envies, que ce soit pour un anniversaire, un événement particulier ou simplement pour se faire plaisir.",
    "Chez Rim'pâtisse, chaque commande est préparée avec beaucoup de soin et une attention particulière aux détails. J'aime créer des desserts qui vous ressemblent, aussi beaux que gourmands, et qui trouvent leur place dans vos plus beaux moments.",
    "Parce qu'au fond, Rim'pâtisse, c'est un peu Rim qui pâtisse… mais surtout Rim qui vous régale. 🥰",
    "Merci pour votre confiance et pour toutes les belles occasions que vous me permettez d'accompagner.",
    "Et maintenant, à vous de me dire : qu'est-ce que Rim'pâtisse pour vous ?",
  ],
  stats: [
    { value: "+500", label: "créations réalisées" },
    { value: "4 ans", label: "d'expérience" },
    { value: "100%", label: "fait maison" },
  ],
};

export const testimonials = [
  { name: "Sophie L.", text: "Un gâteau de mariage à couper le souffle, et un goût divin. Merci pour la magie !", rating: 5 },
  { name: "Marc D.", text: "Le trompe-l'œil a bluffé tous nos invités. Personne ne voulait le couper !", rating: 5 },
  { name: "Inès B.", text: "Des cupcakes délicieux et si jolis. Service impeccable du devis à la livraison.", rating: 5 },
];
